<template>
  <div class='h-outTabs'>
    <div id='nssiTable' class='h100vh-140'>
      <NSSIMenu @methodEnum='methodEnum'></NSSIMenu>
      <NSSITable ref="nssiTable"></NSSITable>
    </div>
  </div>
</template>
<script>
import NSSIMenu from './NSSIMenu';
import NSSITable from './NSSITable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'nssiList',
  components: {
    NSSIMenu,
    NSSITable
  },
  data() {
    return {
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.nssiTable.page.pageNo = "1";
          this.$refs.nssiTable.getNSSIListData();
          break;
        case 'delete':
          this.$refs.nssiTable.deleteNSSI();
          break;
        case 'editLicense':
          this.$refs.nssiTable.editLicenseDialog();
          break;    
        default:
      }
    }
  },
  mounted() {
  }
};
</script>
